import Vue from "vue";
import Vuex from "vuex";
import { setToStorage, getFromStorage } from "@/service/utils";

Vue.use(Vuex);
const MODE_KEY = "MODE";
const FONTSIZE_KEY = "FONT_SIZE";
const FONT_KEY = "FONT";
const BG_KEY = "BACKGROUND";

const readModes = {
  DAY: "LIGHT",
  NIGHT: "DARK"
};

const fonts = {
  POLY: "POLY",
  ROBOTO: "ROBOTO"
};

const defaultFontSize = 16;
const maxFontSize = 22;
const minFontSize = 12;
const fontChangeStep = 2;

export default new Vuex.Store({
  state: {
    user: {},
    readMode: getFromStorage(MODE_KEY),
    // if more, try refactor the component and combine them in one object
    fontSize: getFromStorage(FONTSIZE_KEY) || defaultFontSize,
    font: getFromStorage(FONT_KEY),
    background: getFromStorage(BG_KEY),
    showContinueBtn: true
  },
  mutations: {
    HIDE_CONTINUE_BTN(state) {
      state.showContinueBtn = false;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_FONT(state, font) {
      state.font = font || fonts.ROBOTO;
      setToStorage(FONT_KEY, font);
    },
    TOGGLE_READ_MODE(state, mode) {
      let realMode = mode ? mode : state.readMode === readModes.DAY ? readModes.NIGHT : readModes.DAY;
      state.readMode = realMode;
      setToStorage(MODE_KEY, realMode);
    },
    SET_FONTSIZE(state, tag) {
      let baseSize = state.fontSize;
      if (tag > 0 && baseSize + fontChangeStep <= maxFontSize) {
        baseSize = baseSize + fontChangeStep;
      } else if (tag < 0 && baseSize - fontChangeStep >= minFontSize) {
        baseSize = baseSize - fontChangeStep;
      }
      state.fontSize = baseSize;
      setToStorage(FONTSIZE_KEY, baseSize);
    },
    SET_BACKGROUND(state, background) {
      state.background = background;
      setToStorage(BG_KEY, background);
    }
  },
  actions: {},
  modules: {}
});
